/*
 * On the internet site http://devblogs.nvidia.com/parallelforall/thinking-parallel-part-iii-tree-construction-gpu/
 * Tero Karras explains how to create a Linear Bounding Volume Hirarchie with a GPU.
 * He first explains how to do it the normal way and then how to do it much faster in 
 * a parallel GPU world. 
 * 
 * I just took the first part to see if the concept of LBVH is a good way to 
 * fasten the raytracer of three.js.
 * 
 *  
 * I would create a BVH-Tree data structure with raycasting capability,
 * and i would create LBVH-Tree-Creator. 
 * 
 * This way we could create manny different BVH-Tree Creators/Managers and test different
 * BVH-Tree versoins. 
 * 
 * 
 */
import {THREE} from "./three.js";
THREE.BVH = {};


THREE.BVH.TreeNode = function ( parentNode ) { 
		'use strict';
	
		this.parentNode = (parentNode !== undefined ? parentNode : null);
		this.childNodes	= [];
		
		this.boundingSphere		= null;
		this.boundingBox		= null;
			
};




THREE.BVH.TreeNode.prototype = {
	
	constructor	: THREE.BVHTreeNode,

	intersectsObjectSpaceRay : function ( objectSpaceRay, near, far, intersects ) {
		'use strict';
		var hit, i, l;
		
		// test if the ray hits our node.
		if (this.boundingBox) {
			hit = objectSpaceRay.isIntersectionBox( this.boundingBox );

		} else if (this.boundingSphere) {
			
			hit = objectSpaceRay.isIntersectionSphere( this.boundingSphere ) ;
			
		} else {			
			throw('Bounding volume is not set or not yet supported from the intersectRay function.');
		}
		
		
		// if the ray hits the bounding volume we ned to test the child nodes. 
		if (hit) {
			for (i = 0, l = this.childNodes.length; i < l; i+=1) {
				this.childNodes[i].intersectsObjectSpaceRay( objectSpaceRay, near, far, intersects );
			}
		}
	}
		
};

THREE.BVH.FaceLeaf = function(parentNode) {
	'use strict';
	
	this.parentNode = (parentNode !== undefined ? parentNode : null);
	
	this.mesh		= null;
	this.faceIndex	= null;
	this.bufferGeometryIndexOffset = 0;	

	this.boundingSphere		= null;
	this.boundingBox		= null;		
};

THREE.BVH.FaceLeaf.prototype = {
	
	constructor	: THREE.BVHTreeLeaf_Face,
	
	// Test if the ray hit the face.
	intersectsObjectSpaceRay : function ( objectSpaceRay, near, far, intersects ) {
		
		this.mesh.objectSpaceRayIntersectsFace(this.faceIndex , objectSpaceRay, near, far,  intersects)
				
	}
};










/// LBVH implimentation

THREE.LBVH = {



	// Calculate a 30-bit Morton Code for the
	// given 3D point located within the unit cube [ 0, 1 ].
	createMorton3Dcode : function() {
		'use strict';
		var xx, yy, zz,
		
		// Expands a 10-bit integer into a 30 bits
		// by inserting 2 zeros after each bit. 
	    expandBits = function( value ) {
			value = Math.floor(value);
			value = (value * 0x00010001) & 0xFF0000FF;
			value = (value * 0x00000101) & 0x0F00F00F;
			value = (value * 0x00000011) & 0xC30C30C3;
			value = (value * 0x00000005) & 0x49249249;
			return value;
		};	
			
		return function( x, y, z) {
		
			x = Math.min( Math.max( x * 1024, 0 ), 1023 );
			y = Math.min( Math.max( y * 1024, 0 ), 1023 );
			z = Math.min( Math.max( z * 1024, 0 ), 1023 );
			
			xx = expandBits( x );
			yy = expandBits( y );
			zz = expandBits( z );
			
			return xx * 4 + yy * 2 + zz;
		};
	}(),
	
	
	findSplit : function () {
		'use strict';
		var clz = function (value) {
				return 32 - value.toString(2).length;
			},		
			firstCode,
		    lastCode,
		    commonPrefix,
		    splitPrefix,
		    split,
		    step,
		    newSplit; 
		 
		return function(sortedMortonCodes, first, last ) { 
			
			firstCode = sortedMortonCodes[first].mortenCode;
		    lastCode  = sortedMortonCodes[last].mortenCode;
		 
			if (firstCode === lastCode) { 
				return (first + last) >> 1 ;  // bitwise "div 2" results in a integer. 
			}
			
			commonPrefix = clz(firstCode ^ lastCode);
			 
			split = first ;
			step = last - first;
			
			do  {
				step = ( step + 1 ) >> 1; // exponential decrease. (bitwise "div 2" results in a integer.)
				newSplit = split + step;  // proposed new position
				
				if ( newSplit < last ) {
					splitPrefix = clz( firstCode -  sortedMortonCodes[newSplit].mortenCode);			
					if (splitPrefix > commonPrefix) { split = newSplit; }
				}	
			}
			while ( step > 1 );
			
			return split;
		};
		
	}(),
	
	
	createHirarchy : function ( sortedMortonCodes, first, last ) {
		'use strict';
		var split, childA, childB, resultNode;

		// single object --> return leaf node	
		if (first === last) { 
				resultNode = new THREE.BVH.FaceLeaf(); 
				
				resultNode.mesh = sortedMortonCodes[first].mesh;
				resultNode.faceIndex = sortedMortonCodes[first].faceIndex;

				resultNode.boundingBox = new THREE.Box3();
				resultNode.boundingBox.expandByPoint(sortedMortonCodes[first].vA);
				resultNode.boundingBox.expandByPoint(sortedMortonCodes[first].vB);
				resultNode.boundingBox.expandByPoint(sortedMortonCodes[first].vC);
				
				return resultNode;
			}
		
		// Determine where to split the range
		split = this.findSplit( sortedMortonCodes, first, last );
		
		// Process the resulting sub-ranges recursively
		childA = this.createHirarchy( sortedMortonCodes, first, split );
		childB = this.createHirarchy( sortedMortonCodes, split + 1, last ); 
		
		resultNode = new THREE.BVH.TreeNode();	
		resultNode.childNodes.push( childA );
		resultNode.childNodes.push( childB );
			
		resultNode.boundingBox = new THREE.Box3();
		resultNode.boundingBox.expandByPoint( childA.boundingBox.min );
		resultNode.boundingBox.expandByPoint( childA.boundingBox.max );
		resultNode.boundingBox.expandByPoint( childB.boundingBox.min );
		resultNode.boundingBox.expandByPoint( childB.boundingBox.max );
		
		return resultNode;
		
	},
	
	
	
	createTree : function(){
		'use strict';
		
		var vA = new THREE.Vector3();
		var vB = new THREE.Vector3();
		var vC = new THREE.Vector3();
	
		var geometrySize = new THREE.Vector3(); 
		var centerX, centerY, centerZ;
		
		
		// For each triangle try to calculate a MortonCode.
		// We save the FaceIndex and for later use in the bonding volume the 
		// VA, VB and VC coordinate.
		return function(mesh) {
	
			var sortedMortonCodes = [];
			var geometry = mesh.geometry;
			
			if ( geometry.boundingBox === null ) geometry.computeBoundingBox();
	 		geometry.boundingBox.size(geometrySize); 
			
	
			if ( geometry instanceof THREE.BufferGeometry ) {
	
				var attributes = geometry.attributes;
				var a, b, c;
	
				if ( geometry.index  ) {
	
					var indices = geometry.index.array;
					var positions = attributes.position.array;
					var groups = geometry.groups;
	
					if ( groups.length === 0 ) {
	
						groups = [ { start: 0, count: indices.length, index: 0 } ];
	
					}
	
					for ( var oi = 0, ol = groups.length; oi < ol; ++oi ) {
	
						var start = groups[ oi ].start;
						var count = groups[ oi ].count;
	
						for ( var i = start, il = start + count; i < il; i += 3 ) {
	
							a = ( indices[ i ] ) * 3;
							b = ( indices[ i + 1 ] ) * 3;
							c = ( indices[ i + 2 ] ) * 3;
	
							vA.fromArray( positions, a );
							vB.fromArray( positions, b );
							vC.fromArray( positions, c );
	
							// calc triangle bounding box center
							centerX = ( Math.min( vA.x, vB.x, vC.x ) + Math.max( vA.x, vB.x, vC.x ) ) / 2; 
							centerY = ( Math.min( vA.y, vB.y, vC.y ) + Math.max( vA.y, vB.y, vC.y ) ) / 2; 
							centerZ = ( Math.min( vA.z, vB.z, vC.z ) + Math.max( vA.z, vB.z, vC.z ) ) / 2;
							
							// put this center to range 0 to 1 of the geometry bounding box.
							centerX = ( centerX - geometry.boundingBox.min.x ) / geometrySize.x ;
							centerY = ( centerY - geometry.boundingBox.min.y ) / geometrySize.y ;
							centerZ = ( centerZ - geometry.boundingBox.min.z ) / geometrySize.z ;
							
							// input data.
							sortedMortonCodes.push( { mortonCode : this.createMorton3Dcode(centerX, centerY, centerZ), mesh : mesh, faceIndex : i/3,  vA : new THREE.Vector3().copy(vA), vB : new THREE.Vector3().copy(vB), vC : new THREE.Vector3().copy(vC)} );
						}
	
					}
	
				} else {
	
					var positions = attributes.position.array;
	
					for ( var i = 0, j = 0, jl = positions.length; j < jl; i += 1, j += 9 ) {
	
						vA.fromArray( positions, j );
						vB.fromArray( positions, j + 3 );
						vC.fromArray( positions, j + 6 );
	
						// calc triangle bounding box center
						centerX = ( Math.min( vA.x, vB.x, vC.x ) + Math.max( vA.x, vB.x, vC.x ) ) / 2; 
						centerY = ( Math.min( vA.y, vB.y, vC.y ) + Math.max( vA.y, vB.y, vC.y ) ) / 2; 
						centerZ = ( Math.min( vA.z, vB.z, vC.z ) + Math.max( vA.z, vB.z, vC.z ) ) / 2;
						
						// put this center to range 0 to 1 of the geometry bounding box.
						centerX = ( centerX - geometry.boundingBox.min.x ) / geometrySize.x ;
						centerY = ( centerY - geometry.boundingBox.min.y ) / geometrySize.y ;
						centerZ = ( centerZ - geometry.boundingBox.min.z ) / geometrySize.z ;
	
						sortedMortonCodes.push( { mortonCode : this.createMorton3Dcode(centerX, centerY, centerZ), mesh : mesh, faceIndex: i, vA : new THREE.Vector3().copy(vA), vB : new THREE.Vector3().copy(vB), vC : new THREE.Vector3().copy(vC)} );
					}
	
				}
	
			} else if ( geometry instanceof THREE.Geometry ) {
	
				var vertices = geometry.vertices;
								
				for ( var f = 0, fl = geometry.faces.length; f < fl; f ++ ) {
	
					var face = geometry.faces[ f ];

					var isFaceMaterial = mesh.material instanceof THREE.MeshFaceMaterial;
					var objectMaterials = (isFaceMaterial === true ? mesh.material.materials : null);
					var material = (isFaceMaterial === true ? objectMaterials[ face.materialIndex ] : mesh.material);

	
					a = vertices[ face.a ];
					b = vertices[ face.b ];
					c = vertices[ face.c ];
	
					vA.set( 0, 0, 0 );
					vB.set( 0, 0, 0 );
					vC.set( 0, 0, 0 );
	
					if ( material.morphTargets === true ) {
	
						var morphTargets = geometry.morphTargets;
						var morphInfluences = mesh.morphTargetInfluences;
	
						for ( var t = 0, tl = morphTargets.length; t < tl; t ++ ) {
	
							var influence = morphInfluences[ t ];
	
							if ( influence === 0 ) continue;
	
							var targets = morphTargets[ t ].vertices;
	
							vA.x += ( targets[ face.a ].x - a.x ) * influence;
							vA.y += ( targets[ face.a ].y - a.y ) * influence;
							vA.z += ( targets[ face.a ].z - a.z ) * influence;
	
							vB.x += ( targets[ face.b ].x - b.x ) * influence;
							vB.y += ( targets[ face.b ].y - b.y ) * influence;
							vB.z += ( targets[ face.b ].z - b.z ) * influence;
	
							vC.x += ( targets[ face.c ].x - c.x ) * influence;
							vC.y += ( targets[ face.c ].y - c.y ) * influence;
							vC.z += ( targets[ face.c ].z - c.z ) * influence;
	
						}
	
	
					}
					
					vA.add( a );
					vB.add( b );
					vC.add( c );
	
					// calc triangle bounding box center
					centerX = ( Math.min( vA.x, vB.x, vC.x ) + Math.max( vA.x, vB.x, vC.x ) ) / 2; 
					centerY = ( Math.min( vA.y, vB.y, vC.y ) + Math.max( vA.y, vB.y, vC.y ) ) / 2; 
					centerZ = ( Math.min( vA.z, vB.z, vC.z ) + Math.max( vA.z, vB.z, vC.z ) ) / 2;
					
					// put this center to range 0 to 1 of the geometry bounding box.
					centerX = ( centerX - geometry.boundingBox.min.x ) / geometrySize.x ;
					centerY = ( centerY - geometry.boundingBox.min.y ) / geometrySize.y ;
					centerZ = ( centerZ - geometry.boundingBox.min.z ) / geometrySize.z ;
		
					sortedMortonCodes.push( { mortonCode : this.createMorton3Dcode(centerX, centerY, centerZ), mesh : mesh, faceIndex: f, vA : new THREE.Vector3().copy(vA), vB : new THREE.Vector3().copy(vB), vC : new THREE.Vector3().copy(vC)} );
				}	
			}
		
			// Now we have all faces and the MortonCodes.
			sortedMortonCodes.sort( function(a,b){ return a.mortonCode - b.mortonCode } );
		
			// create hirarchy and return it.
			return this.createHirarchy( sortedMortonCodes, 0, sortedMortonCodes.length - 1 );		
			
		};
			
		
	}()



};









//
//
//  Changes to standard ThreeJS.
//  These functions have been declined for merge, but they are needed for BVH-Trees:
//
//  THREE.Mesh.prototype.objectSpaceRayIntersectsFace()
//  THREE.Mesh.prototype.raycast()
//
//  These functions are changed to determine if the ray intersects the FrontSide or BackSide
//
//  THREE.Ray.prototype.intersectTriangle()
//

THREE.Ray.prototype.intersectTriangle = function () {

	// Compute the offset origin, edges, and normal.
	var diff = new THREE.Vector3();
	var edge1 = new THREE.Vector3();
	var edge2 = new THREE.Vector3();
	var normal = new THREE.Vector3();

	return function ( a, b, c, backfaceCulling, optionalTarget ) {

		// from http://www.geometrictools.com/LibMathematics/Intersection/Wm5IntrRay3Triangle3.cpp

		edge1.subVectors( b, a );
		edge2.subVectors( c, a );
		normal.crossVectors( edge1, edge2 );

		// Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
		// E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
		//   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
		//   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
		//   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
		var DdN = this.direction.dot( normal );
		var sign;

		if ( DdN > 0 ) {

			if ( backfaceCulling ) return null;
			sign = 1;

		} else if ( DdN < 0 ) {

			sign = - 1;
			DdN = - DdN;

		} else {

			return null;

		}

		diff.subVectors( this.origin, a );
		var DdQxE2 = sign * this.direction.dot( edge2.crossVectors( diff, edge2 ) );

		// b1 < 0, no intersection
		if ( DdQxE2 < 0 ) {

			return null;

		}

		var DdE1xQ = sign * this.direction.dot( edge1.cross( diff ) );

		// b2 < 0, no intersection
		if ( DdE1xQ < 0 ) {

			return null;

		}

		// b1+b2 > 1, no intersection
		if ( DdQxE2 + DdE1xQ > DdN ) {

			return null;

		}

		// Line intersects triangle, check if ray does.
		var QdN = - sign * diff.dot( normal );

		// t < 0, no intersection
		if ( QdN < 0 ) {

			return null;

		}

		// Ray intersects triangle.
		optionalTarget = this.at( QdN / DdN, optionalTarget );
		optionalTarget.intersectsFrontSide = ( sign === -1 );
		return optionalTarget;

	};

}();



THREE.Mesh.prototype.objectSpaceRayIntersectsFace = function() {

	var vA = new THREE.Vector3();
	var vB = new THREE.Vector3();
	var vC = new THREE.Vector3();

	var intersectionPoint = new THREE.Vector3();
	var intersectionPointWorld = new THREE.Vector3();
	var originWorld = new THREE.Vector3();

	var a, b, c, tmpFace;

	var uvA = new THREE.Vector2();
	var uvB = new THREE.Vector2();
	var uvC = new THREE.Vector2();

	var barycoord = new THREE.Vector3();


	function uvIntersection( point, p1, p2, p3, uv1, uv2, uv3 ) {

		THREE.Triangle.barycoordFromPoint( point, p1, p2, p3, barycoord );

		uv1.multiplyScalar( barycoord.x );
		uv2.multiplyScalar( barycoord.y );
		uv3.multiplyScalar( barycoord.z );

		uv1.add( uv2 ).add( uv3 );

		return uv1.clone();

	}


	return function(faceIndex, objectSpaceRay, near, far,  intersects) {

		var uv = undefined;
		var uvs = undefined;
		var geometry = this.geometry;


		var material = this.material;
		if ( material === undefined ) return;

		if ( geometry instanceof THREE.BufferGeometry ) {

			var attributes = geometry.attributes;
			var positions = attributes.position.array;

			// Indexed-BufferGeometry
			if ( geometry.index !== null ) {

				var indices = geometry.index.array;

				a = ( indices[ faceIndex*3 ] )      ;
				b = ( indices[ faceIndex*3 + 1 ] )  ;
				c = ( indices[ faceIndex*3 + 2 ] )  ;

			} else {

				a = faceIndex*3 ;
				b = faceIndex*3 + 1;
				c = faceIndex*3 + 2;

			}

			vA.fromArray( positions, a *3 );
			vB.fromArray( positions, b *3 );
			vC.fromArray( positions, c *3 );

			tmpFace = new THREE.Face3( a,b,c, THREE.Triangle.normal( vA, vB, vC ) );

			if ( attributes.uv !== undefined ) {

				uvs = attributes.uv.array;
				uvA.fromArray( uvs, a * 2 );
				uvB.fromArray( uvs, b * 2 );
				uvC.fromArray( uvs, c * 2 );

			}




		} else if ( this.geometry instanceof THREE.Geometry ) {

			tmpFace = geometry.faces[ faceIndex ];

			var isFaceMaterial = this.material instanceof THREE.MeshFaceMaterial;
			var objectMaterials = (isFaceMaterial === true ? this.material.materials : null);
			material = (isFaceMaterial === true ? objectMaterials[ tmpFace.materialIndex ] : this.material);


			if ( material === undefined ) return;

			vertices = geometry.vertices;

			a = vertices[ tmpFace.a ];
			b = vertices[ tmpFace.b ];
			c = vertices[ tmpFace.c ];

			vA.set( 0, 0, 0 );
			vB.set( 0, 0, 0 );
			vC.set( 0, 0, 0 );


			if ( material.morphTargets === true ) {

				var morphTargets = geometry.morphTargets;
				var morphInfluences = this.morphTargetInfluences;

				for ( var t = 0, tl = morphTargets.length; t < tl; t ++ ) {

					var influence = morphInfluences[ t ];

					if ( influence === 0 ) return;

					var targets = morphTargets[ t ].vertices;

					vA.addScaledVector( tempA.subVectors( targets[ tmpFace.a ], a ), influence );
					vB.addScaledVector( tempB.subVectors( targets[ tmpFace.b ], b ), influence );
					vC.addScaledVector( tempC.subVectors( targets[ tmpFace.c ], c ), influence );

				}

			}

			vA.add( a );
			vB.add( b );
			vC.add( c );

			if ( geometry.faceVertexUvs[ 0 ].length > 0 ) {

				uvs = geometry.faceVertexUvs[ 0 ][ 0 ];
				uvA.copy( uvs[ 0 ] );
				uvB.copy( uvs[ 1 ] );
				uvC.copy( uvs[ 2 ] );

			}


		} else {
			console.warn('objectSpaceRayIntersectsFace: The type of the geometry is not supported.');
			return;
		}




		if ( material.side === THREE.BackSide ) {

			if ( objectSpaceRay.intersectTriangle( vC, vB, vA, true, intersectionPoint ) === null ){ return; } ;

		} else {

			if ( objectSpaceRay.intersectTriangle( vA, vB, vC, material.side !== THREE.DoubleSide, intersectionPoint ) === null ){ return; };

		}

		intersectionPointWorld.copy( intersectionPoint );
		intersectionPointWorld.applyMatrix4( this.matrixWorld );

		// To calculate the correct distance we need to calculate the distance between the world intersection point
		// and the world ray origin.  (If we didn't do that the distance will be off by the object scaling factor.)
		originWorld.copy(objectSpaceRay.origin).applyMatrix4( this.matrixWorld );
		var distance = originWorld.distanceTo( intersectionPointWorld );

		if ( distance < near || distance > far ) return;

		if ( uvs !== undefined ) {

			uv = uvIntersection(intersectionPoint, vA, vB, vC, uvA, uvB, uvC);

		}

		intersects.push( {

			distance: distance,
			point: intersectionPointWorld.clone(),
			uv: uv,
			face: tmpFace,
			faceIndex: faceIndex,
			object: this,
			intersectsFrontSide : intersectionPoint.intersectsFrontSide

		} );
	};
}();


THREE.Mesh.prototype.raycast = ( function () {

	var inverseMatrix = new THREE.Matrix4();
	var ray = new THREE.Ray();

	return function ( raycaster, intersects ) {

		if ( this.material === undefined ) return;

		var geometry = this.geometry;

		inverseMatrix.getInverse( this.matrixWorld );
		ray.copy( raycaster.ray ).applyMatrix4( inverseMatrix );

		if ( geometry.boundingSphere === null ) geometry.computeBoundingSphere();

		if ( ray.isIntersectionSphere( geometry.boundingSphere ) === false ) {

			return;

		}

		if (this.BVHTree) {

			this.BVHTree.intersectsObjectSpaceRay(ray, raycaster.near, raycaster.far, intersects);
			return;

		}

		if ( geometry.boundingBox !== null ) {

			if ( ray.isIntersectionBox( geometry.boundingBox ) === false )  {

				return;

			}

		}

		if ( geometry instanceof THREE.BufferGeometry ) {

			var attributes = geometry.attributes;
			var positions = attributes.position.array;

			if ( geometry.index !== null ) {

				var indices = geometry.index.array;
				var groups = geometry.groups;

				if ( groups.length === 0 ) {

					groups = [ { start: 0, count: indices.length } ];

				}

				for ( var oi = 0, ol = groups.length; oi < ol; ++oi ) {

					var start = groups[ oi ].start;
					var count = groups[ oi ].count;

					for ( var i = start / 3, il = (start + count) / 3; i < il; i += 1 ) {

						this.objectSpaceRayIntersectsFace(i, ray,  raycaster.near, raycaster.far, intersects);

					}

				}

			} else {

				for ( var i = 0,  l = positions.length / 9; i < l; i += 1 ) {

					this.objectSpaceRayIntersectsFace(i, ray, raycaster.near, raycaster.far,  intersects);

				}

			}

		} else if ( geometry instanceof THREE.Geometry ) {

			for ( var f = 0, fl = geometry.faces.length; f < fl; f ++ ) {

				this.objectSpaceRayIntersectsFace(f, ray, raycaster.near, raycaster.far, intersects);

			}

		}

	};

}() );

export {THREE};














